import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function CtaSection() {
  return <section id="precio" className="pt-12 pb-24 px-6 md:px-12 bg-[#0a0e1a] text-[#f5f5f0] relative overflow-hidden" data-id="element-19">
      {/* Top gradient glow */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-amber-900/10 to-transparent pointer-events-none" data-id="element-20" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center space-y-8" data-id="element-21">
        <div className="space-y-6 text-xl md:text-2xl leading-relaxed font-light text-gray-300" data-id="element-22">
          <p data-id="element-23">No prometo que nunca más vas a tener ganas.</p>
          <p className="text-white font-medium" data-id="element-24">
            Prometo algo más útil:
            <br data-id="element-25" />
            vas a saber qué hacer cuando aparezcan.
          </p>
          <p data-id="element-26">
            Porque la vida no te pregunta si estás listo.
            <br data-id="element-27" />
            La noche llega igual.
          </p>
          <p className="text-amber-400 font-serif italic text-3xl" data-id="element-28">
            Y esta vez, vas a tener un cierre.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-29">
          {/* Pricing */}
          <div className="flex items-center gap-3" data-id="element-30">
            <span className="text-gray-500 line-through text-lg" data-id="element-31">19,99€</span>
            <span className="text-white font-bold text-4xl" data-id="element-32">6,36€</span>
            <span className="bg-amber-500 text-[#0a0e1a] text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full" data-id="element-33">
              68% OFF
            </span>
          </div>

          <CtaButton text="Accede al plan 'Cero Atracones Nocturnos' (14 días)" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Cero Atracones Nocturnos (14 días)',
              content_type: 'product',
              value: 6.36,
              currency: 'EUR'
            });
          }
          window.open('https://www.warame.com/cart/56917256962430:1', '_blank');
        }} className="w-full sm:w-auto text-lg md:text-xl py-5 px-10" data-id="element-34" />
          <p className="text-gray-500 text-sm tracking-wide uppercase" data-id="element-35">
            Empieza hoy
          </p>
        </div>
      </motion.div>
    </section>;
}